<template>
  <section id="contact" class="contact">
    <div class="shell">
      <div v-reveal class="contact-card">
        <img
          class="contact-bg"
          src="/photos/contact.webp"
          srcset="/photos/contact-900.webp 900w, /photos/contact.webp 1800w"
          sizes="(max-width: 760px) 300px, 1200px"
          alt=""
          width="1800"
          height="1153"
          loading="lazy"
          decoding="async"
        />
        <div class="contact-main">
          <h2>Tell me what you’re working on</h2>
          <p class="contact-intro">
            Have a project in mind, or a process that’s eating your time? Send
            me a message on WhatsApp. I’ll read it myself and let you know how I
            can help.
          </p>
          <div class="contact-actions">
            <a
              class="btn btn-primary btn-icon"
              :href="contact.whatsappUrl"
              target="_blank"
              rel="noopener noreferrer"
              ><WhatsAppIcon />Chat on WhatsApp<span class="sr-only">
                (opens WhatsApp)</span
              ></a
            >
            <a class="btn btn-ghost" :href="`mailto:${contact.email}`"
              >Email me</a
            >
          </div>
        </div>
        <ul class="contact-list">
          <li>
            <a
              :href="contact.whatsappUrl"
              target="_blank"
              rel="noopener noreferrer"
              ><span class="contact-label">WhatsApp</span
              ><span class="contact-value"
                >{{ contact.phoneDisplay }} <span aria-hidden="true">↗</span
                ><span class="sr-only"> (opens WhatsApp)</span></span
              ></a
            >
          </li>
          <li>
            <a :href="`mailto:${contact.email}`"
              ><span class="contact-label">Email</span
              ><span class="contact-value">{{ contact.email }}</span></a
            >
          </li>
          <li>
            <a :href="contact.phoneHref"
              ><span class="contact-label">Call</span
              ><span class="contact-value">{{ contact.phoneDisplay }}</span></a
            >
          </li>
          <li>
            <a
              :href="contact.instagramUrl"
              target="_blank"
              rel="noopener noreferrer"
              ><span class="contact-label">Instagram</span
              ><span class="contact-value"
                >@westdevsolutionsllc <span aria-hidden="true">↗</span
                ><span class="sr-only"> (opens in a new tab)</span></span
              ></a
            >
          </li>
        </ul>
      </div>
      <div class="contact-share">
        <a href="/connect" class="contact-qr-link"><img src="/contact-qr.svg" width="112" height="112" alt="Scan to open all West Dev Solutions contact links" /></a>
        <div><p class="eyebrow">KEEP IN TOUCH</p><h3>All my links. One place.</h3><p>Scan to find Instagram, WhatsApp, email and more.</p><a href="/connect" class="text-link">Open contact hub →</a></div>
        <a class="btn contact-download" href="/contact-qr.png" download>Download QR ↓</a>
      </div>
    </div>
  </section>
</template>
<script>
import WhatsAppIcon from "@/components/graphics/WhatsAppIcon.vue";
import contact from "@/config/contact";

export default {
  name: "ContactSection",
  components: { WhatsAppIcon },
  data: () => ({ contact }),
};
</script>
